var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.01,
    width: 22,
    height: 22,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.77033 3.37436C5.49916 3.80093 4.58333 5.00187 4.58333 6.41671V8.70837H17.4167V6.41671C17.4167 5.00187 16.5008 3.80093 15.2297 3.37436C14.8961 3.82951 14.3576 4.12504 13.75 4.12504H8.25C7.64245 4.12504 7.10392 3.82951 6.77033 3.37436ZM19.25 8.70837V6.41671C19.25 4.04763 17.616 2.06021 15.4135 1.51999C15.1221 0.893061 14.4868 0.458374 13.75 0.458374H8.25C7.51316 0.458374 6.87785 0.89306 6.58652 1.51998C4.38403 2.06021 2.75 4.04763 2.75 6.41671V8.70837H1.83333C0.820811 8.70837 0 9.52919 0 10.5417C0 11.2877 0.445522 11.9296 1.085 12.2159L2.28733 17.6264C2.79571 19.914 4.82477 21.5417 7.16827 21.5417H14.8317C17.1752 21.5417 19.2043 19.914 19.7127 17.6264L20.915 12.2159C21.5545 11.9296 22 11.2877 22 10.5417C22 9.52919 21.1792 8.70837 20.1667 8.70837H19.25ZM11 12.7024C10.5359 12.7024 10.1597 13.0786 10.1597 13.5427V17.624C10.1597 18.0881 10.5359 18.4643 11 18.4643C11.4641 18.4643 11.8403 18.0881 11.8403 17.624V13.5427C11.8403 13.0786 11.4641 12.7024 11 12.7024ZM15.0304 13.3477C15.1598 12.9337 15.586 12.6891 16.0087 12.7862C16.4802 12.8945 16.7597 13.3814 16.6153 13.8432L15.3724 17.819C15.243 18.233 14.8168 18.4776 14.3941 18.3805C13.9226 18.2722 13.6431 17.7853 13.7875 17.3236L15.0304 13.3477ZM5.99131 12.7862C5.51978 12.8945 5.24034 13.3814 5.38469 13.8432L6.62758 17.819C6.75699 18.233 7.1832 18.4776 7.60591 18.3805C8.07744 18.2722 8.35688 17.7854 8.21253 17.3236L6.96964 13.3477C6.84024 12.9337 6.41402 12.6891 5.99131 12.7862Z",
    fill: "#D5DAE0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBag);
export default __webpack_public_path__ + "static/media/bag.58c3c45735780043e0d679b84129d696.svg";
export { ForwardRef as ReactComponent };